<template>
  <svg
    data-test="extension-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.162 20"
  >
    <g>
      <path
        fill="currentColor"
        d="M10.006,20C4.495,20,0,15.505,0,9.994c0-5.407,4.235-9.798,9.628-9.993
		c0.365-0.013,0.664,0.195,0.795,0.509c0.143,0.325,0.052,0.703-0.196,0.938C8.742,2.802,7.921,4.652,7.921,6.658
		c0,3.909,3.18,7.088,7.088,7.088c1.029,0,2.02-0.222,2.971-0.664c0.326-0.144,0.691-0.078,0.938,0.169
		c0.248,0.248,0.313,0.626,0.17,0.939C17.458,17.72,13.889,20,10.006,20z M15.009,15.414c-4.834,0-8.756-3.922-8.756-8.756
		c0-1.655,0.483-3.27,1.355-4.651C4.143,3.036,1.668,6.215,1.668,9.994c0,4.599,3.739,8.338,8.338,8.338
		c2.514,0,4.873-1.146,6.436-3.036C15.973,15.375,15.491,15.414,15.009,15.414z"
      />
    </g>
  </svg>
</template>
